import React from "react";
import { Container, Row, Col } from "react-bootstrap";
import "./Draft.css";
import { Helmet, HelmetProvider } from "react-helmet-async";

export default function Draft1() {
  return (
    <>
    <HelmetProvider>
        <Helmet>
            <meta name="robots" content="noindex, nofollow" />
        </Helmet>
    </HelmetProvider>
    
   
      <div className="draft-main">
        <Container>
          <Row>
            <Col>
              <ul className="navigator-arrow">
                <li>
                  <a href="/">
                    <i className="fa fa-home" aria-hidden="true"></i>
                  </a>{" "}
                  <i className="fa fa-angle-right" aria-hidden="true"></i>
                </li>
                <li>Thank You for empanelment</li>
              </ul>
            </Col>
          </Row>
        </Container>
        <Container>
          <div className="draft-inner-main">
            <span>
              Thank you for choosing to empanel with JM Financial Mutual Fund.
            </span>
            <span>
              At JM Financial Mutual Fund, we firmly believe that the success of
              our Partners is our success.
            </span>
            <span>
              A standard empanelment email with all the relevant details will
              follow. Do visit the website{" "}
              <a href="http://www.JMFinancialMF.com">www.JMFinancialMF.com</a>{" "}
              for details on our Schemes.
            </span>
            <span>In agreeing to being empanelled with us, it is deemed that you have read and accepted our terms and conditions of empanelment. </span>
            <span>
              We look forward to working together and building a strong and
              mutually beneficial partnership for a long time.
            </span>
            <br />
            <span style={{fontWeight : "bold"}}>Mutual Fund investments are subject to market risk, read all scheme related documents carefully. </span>
          </div>
        </Container>
      </div>
    </>
  );
}
